import { CallOutAlertVariant, } from '../../../../../../components/callOutAlert/types/callOutAlertTheme';
import { commonStyles, containersCommonStyles } from '../commonStyles';
export const getIconStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CallOutAlertVariant.ICON]: {
            ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS),
            ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            icon: {
                width: FOUNDATIONS.size_350,
                height: FOUNDATIONS.size_350,
                color: FOUNDATIONS.color_neutral_icon_onsurface_50,
            },
        },
    };
};
//# sourceMappingURL=icon.js.map